import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

/** Element for displaying program code */
export default function BlockCode({ sx, children }: Props): React.ReactNode {
  return (
    <Box
      data-testid='BlockCode'
      component='code'
      sx={{
        display: "block",
        width: "100%",
        overflow: "auto",
        backgroundColor: (t) => t.palette.secondary.light,
        color: (th) => th.palette.secondary.main,
        boxShadow: (th) => th.shadows[1],
        paddingY: 1,
        paddingX: 2,
        borderRadius: "2px",
        whiteSpace: "pre",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
